import { render, staticRenderFns } from "./RecordValidation.vue?vue&type=template&id=0318eb34&scoped=true&"
import script from "./RecordValidation.vue?vue&type=script&lang=js&"
export * from "./RecordValidation.vue?vue&type=script&lang=js&"
import style0 from "./RecordValidation.vue?vue&type=style&index=0&id=0318eb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0318eb34",
  null
  
)

export default component.exports